// Shared look of the I / O / C / X ranging tap buttons (Shelf tab and the
// survey ranging-status renderer, cards #4031 / #3073).
//
// Three states per button:
//   selected -- the tasker tapped it this visit (solid colour + ring)
//   ghost    -- last visit's value: a faded ring only, no fill. Never a
//               pre-selected value, so a row can't pass as answered
//   idle     -- neither
//
// Class names are written out in full so Tailwind sees them (this file is in
// tailwind.config.js `content`).
export const RANGING_VALUES = ["I", "O", "C", "X"]

export const RANGING_LABELS = { I: "In stock", O: "Out of stock", C: "Cut in", X: "Not ranged" }

const SELECTED = {
  I: ["bg-green-100", "text-green-700", "ring-2", "ring-offset-1", "ring-green-500"],
  O: ["bg-orange-100", "text-orange-700", "ring-2", "ring-offset-1", "ring-orange-500"],
  C: ["bg-blue-100", "text-blue-700", "ring-2", "ring-offset-1", "ring-blue-500"],
  X: ["bg-gray-200", "text-gray-600", "ring-2", "ring-offset-1", "ring-gray-400"]
}

const GHOST = {
  I: ["bg-white", "text-slate-500", "ring-2", "ring-offset-1", "ring-green-500/40"],
  O: ["bg-white", "text-slate-500", "ring-2", "ring-offset-1", "ring-orange-500/40"],
  C: ["bg-white", "text-slate-500", "ring-2", "ring-offset-1", "ring-blue-500/40"],
  X: ["bg-white", "text-slate-500", "ring-2", "ring-offset-1", "ring-gray-400/40"]
}

const IDLE = ["bg-slate-100", "text-slate-400"]

const EVERY_CLASS = [...new Set([
  ...Object.values(SELECTED).flat(),
  ...Object.values(GHOST).flat(),
  ...IDLE
])]

// state: "selected" | "ghost" | "idle"
export function applyRangingState(button, value, state) {
  button.classList.remove(...EVERY_CLASS)
  const classes = state === "selected" ? SELECTED[value]
                : state === "ghost"    ? GHOST[value]
                : IDLE
  button.classList.add(...(classes || IDLE))
}
